import * as React from 'react';

import { ErrorBound } from '../ErrorBound';
import { OfferCardContainer } from '../OfferCardContainer';
import { OfferContext } from '../OfferContext';
import { EBrandingLevel, IApplicationContext, IOffer, TUser } from '../../types';
import { ApplicationContext } from '../../context/applicationContext';
import { prepareOffer } from './mappers';
import { NotAvailablePopupContainer } from '../NotAvailablePopupContainer';
import { ChatModalContainer } from '../ChatModalContainer';
import { ChatContextProvider } from '../ChatContextProvider';
import { NotAvailablePopupContextProvider } from '../NotAvailablePopupContextProvider';

interface IOfferContainerProps {
  offer: IOffer;
  context: IApplicationContext;
  user: TUser;

  onCardClick?: VoidFunction;
  onPhoneShow: VoidFunction;
  onChatButtonClick: VoidFunction;
  onChatPopupOpen: VoidFunction;
  onFavoritesAdd: VoidFunction;
  onFavoritesRemove: VoidFunction;
}

export function OfferCardMobileWidgetContainer({
  offer,
  user,
  context,
  onCardClick,
  onPhoneShow,
  onChatButtonClick,
  onChatPopupOpen,
  onFavoritesAdd,
  onFavoritesRemove,
}: IOfferContainerProps) {
  const offerContextData = React.useMemo(() => {
    const extendedOffer = prepareOffer(offer);
    const brandingBannerShown = offer.brandingLevel === EBrandingLevel.ThirdLevel;
    const { author, building } = offer;
    const isFromDeveloper = !!building && (!!author?.fromDeveloper || !!author?.isFromLeadFactory);

    return {
      ...extendedOffer,
      brandingBannerShown,
      isFromDeveloper,
      user,
      tracking: { onPhoneShow, onChatButtonClick, onChatPopupOpen, onFavoritesAdd, onFavoritesRemove },
    };
  }, [offer, onChatButtonClick, onChatPopupOpen, onFavoritesAdd, onFavoritesRemove, onPhoneShow, user]);

  return (
    <ApplicationContext.Provider value={context}>
      <OfferContext.Provider value={offerContextData}>
        <ChatContextProvider>
          <NotAvailablePopupContextProvider>
            <ErrorBound offerId={offer.id} logger={context.logger}>
              <OfferCardContainer onClick={onCardClick} />
              <ChatModalContainer />
              <NotAvailablePopupContainer />
            </ErrorBound>
          </NotAvailablePopupContextProvider>
        </ChatContextProvider>
      </OfferContext.Provider>
    </ApplicationContext.Provider>
  );
}
